import { setLoadingBar } from '../../../Project/bavaria-no/RouteHandler';
import { combineQueries } from './combineQueries';
import { getApiEndpoint } from './filterItems';
import { scrollToSavedPosition } from './scrollPosition';

export const fetchFilterItems = ({
  filterType,
  perPage,
  pageNumber,
  query,
  resetScrollPosition = true,
}) => {
  setLoadingBar(true);
  const finalQuery = combineQueries(`perPage=${perPage}&pageNumber=${pageNumber}`, query);

  const apiEndpoint = getApiEndpoint(filterType);

  setLoadingBar(true);
  return fetch(`${apiEndpoint}?${finalQuery}`)
    .then((res) => res.json())
    .then((res) => {
      if (resetScrollPosition) scrollToSavedPosition();
      setLoadingBar(false);
      return res;
    });
};
